<template>
<div>
  <ul>
    <li v-for="item in audits">
      {{ item.created_at }}<br>
      {{ item.user_name }}
      <ul>
        <li v-for="(what, name, index) in item.modified">{{ name }} - {{ what.old }} - {{ what.new }}</li>
      </ul>
    </li>
  </ul>
</div>
</template>

<script>
export default {
  props: ['audits']
}
</script>
